import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import Modal from '../../../../../common/Modal';
import { Button } from '../../../../../common/index';
import { Coupon, RegenerateType } from '../../../../../types/generated.types';
import AutoResizeTextarea from '../../../../../common/AutoResizeTextarea';

interface ModalRegenerateProps {
  isOpen: boolean;
  coupon: Coupon;
  setContext: (value) => void;
  onClose: () => void;
  onSelect: (type: RegenerateType) => void;
  onSelectFields?: () => void; // New callback for selecting specific fields
}

const ModalRegenerate: React.FC<ModalRegenerateProps> = ({ isOpen, coupon, setContext, onClose, onSelect, onSelectFields }) => {
  const handleSelect = (type: RegenerateType) => {
    onSelect(type);
    onClose();
  };

  const handleSelectFields = () => {
    if (onSelectFields) {
      onSelectFields();
    }
    onClose();
  };

  return (
    <>
      {isOpen && (() => {
        const target = document.getElementById('coupons-manage');
        if (!target) return null;

        return ReactDOM.createPortal(
          <Modal isOpen={isOpen} closeModal={onClose} className="regenerate-type-modal" showClose={false}>
            <div className="regenerate-type-modal-content flex flex-col items-center gap-2 text-center" onPointerDown={e => e.stopPropagation()}>
              <h4>Generera ny kupong med AI?</h4>
              <p>Detta skapar en helt ny kupong och nya motiveringar. Du kan backa direkt efter om du ångrar dig.</p>
              <div className='flex flex-col gap-1'>
                <div className="context-section">
                  <div className="context-header">Instruktioner till AI (valfritt)</div>
                  <AutoResizeTextarea
                    value={coupon.context || ''}
                    onChange={(e) => setContext(e.target.value)}
                    rows={2}
                    placeholder={`ex. "Mössor", "Motiveringen måste vara max 1 mening"`}
                    title="Kontext"
                    onPointerDown={(e) => e.stopPropagation()}
                  />
                </div>
                <Button
                  type="button"
                  className="primary md"
                  onClick={() => handleSelect(RegenerateType.Coupon)}
                >
                  Generera ny kupong
                </Button>

                <Button
                  type="button"
                  className="secondary md"
                  onClick={() => handleSelect(RegenerateType.Assessment)}
                >
                  Generera endast betyget
                </Button>


                <Button
                  type="button"
                  className="secondary md"
                  onClick={handleSelectFields}
                >
                  Generera delar av betyget
                </Button>
              </div>

            </div>
          </Modal>,
          target
        );
      })()}
    </>
  );
}

export default ModalRegenerate;

